import React from "react";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import type { CtaButtonType } from "../../../../utils/types/AceConfigType";
import useCtaButton from "../../../../hooks/useCtaButton";
import Icon from "../../../../../shared-components/css-modules/lexus/atoms/Icon";
import { useCarConfigSelector } from "../../../../redux/store";

const CtaButton = ({
    ctaConfig,
    sizing,
    className,
    useOrderCtaTracking = false,
    showIcon = true,
    disabled = false,
}: {
    ctaConfig: CtaButtonType;
    sizing?: "xs" | "sm" | "lg" | "full-width" | "pill";
    className?: string;
    useOrderCtaTracking?: boolean;
    showIcon?: boolean;
    disabled?: boolean;
}): JSX.Element => {
    const tyCode = useCarConfigSelector((state) => state.save.data?.Personal?.Code || "");
    const modelInfo = useCarConfigSelector((state) => state.car.model);

    const href = ctaConfig.url
        ? ctaConfig.url
              .replace("{configCode}", tyCode)
              .replace("{tyCode}", tyCode)
              .replace("{modelId}", modelInfo.id)
              .replace("{modelCode}", modelInfo.internalCode)
              .replace("{modelName}", modelInfo.name)
        : "";

    const { title, onClick, isPrimary, ctaDisabled } = useCtaButton(ctaConfig, useOrderCtaTracking, href);

    return (
        <Button
            variant={isPrimary ? "btn-default" : "btn-secondary"}
            href={!disabled ? href : ""}
            onClick={(event) => {
                onClick(event);
            }}
            sizing={sizing}
            className={className}
            disabled={disabled || ctaDisabled}
        >
            <span>{title}</span>
            {showIcon && <Icon variant="arrow-long-right" sizing="md" aria-hidden="true" />}
        </Button>
    );
};

export default CtaButton;
